<script setup>
import GenericTooltip from './common/GenericTooltip.vue';
import { computed, ref } from 'vue'
import { useI18n } from 'vue-i18n';
import routeIconDay from '@/assets/images/route/Route_DAY.svg';
import routeIconNight from '@/assets/images/route/Route_NIGHT.svg';
import routeIconDusk from '@/assets/images/route/Route_DUSK.svg';
import { usePortAllData } from '@/stores/portAllData';
import { LIGHT_CONDITION } from '@/plugins/utils/constantes';
import { storeToRefs } from 'pinia';

const store = usePortAllData();
const { getLayerColor } = storeToRefs(store);

const props = defineProps({
  moduleParam: {
    type: Object,
    default: () => {
      return {}
    }
  },
  isActive: {
    type: Boolean,
    default: false
  },
  isProcessing: {
    type: Boolean,
    default: false
  }
})

const { t } = useI18n();

const emit = defineEmits(['click'])

const clickEvent = () => {
  if (!props.isActive) emit('click', props.moduleParam.module)
  else emit('click')
}

const icon = computed(() => {
  if (props.isProcessing) return 'loading'
  return props.moduleParam.icon
})

const routeIcon = computed(() => {
  switch (getLayerColor.value) {
    case LIGHT_CONDITION.DUSK:
      return routeIconDusk
    case LIGHT_CONDITION.NIGHT:
      return routeIconNight
    case LIGHT_CONDITION.DAY:
    default:
      return routeIconDay
  }
})
</script>

<template>
  <generic-tooltip :text="t(moduleParam.module)" position="left">
    <button class="module-button" :class="{ active : isActive }" type="button" @click="clickEvent">
      <img v-if="icon === 'route-image'" class="route-img" :src="routeIcon">
      <i v-else :class="icon" />
    </button>
  </generic-tooltip>
</template>

<i18n src="@/locales/modulesControls.json"></i18n>